import IconButton from "../IconButton/IconButton";
import FeaturedIcon from "../FeaturedIcon/FeaturedIcon";
import styles from "./Drawer.module.scss";
import { Close, IconComponentType } from "../Icon/Icon";
import classNames from "classnames";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { Transition } from "react-transition-group";
import { useRef } from "react";

function Drawer({
  title,
  isOpen,
  onClose,
  children,
  FeaturedIconComponent,
}: {
  title?: string;
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  FeaturedIconComponent?: IconComponentType;
}) {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <DialogPrimitive.Root
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <Transition nodeRef={ref} in={isOpen} timeout={200}>
        {(state) =>
          state === "exited" ? null : (
            <DialogPrimitive.Portal forceMount>
              <div ref={ref} className={classNames(styles.drawer)}>
                <DialogPrimitive.Overlay className={styles.overlay} />
                <DialogPrimitive.Content
                  className={classNames(styles.content, {
                    [styles.contentClosing]: state === "exiting",
                  })}
                >
                  <DialogPrimitive.Title className={styles.header}>
                    {(title || FeaturedIconComponent) && (
                      <div>
                        {FeaturedIconComponent && (
                          <FeaturedIcon
                            className={classNames({
                              [styles.featureIconWithTitle]: !!title,
                            })}
                            IconComponent={FeaturedIconComponent}
                          />
                        )}
                        {title && <p className={styles.title}>{title}</p>}
                      </div>
                    )}
                    <IconButton
                      className={styles.closeButton}
                      iconSize="large"
                      aria-label="Close"
                      IconComponent={Close}
                      onClick={onClose}
                      showTooltip={false}
                    />
                  </DialogPrimitive.Title>
                  <div className={styles.body}>{children}</div>
                </DialogPrimitive.Content>
              </div>
            </DialogPrimitive.Portal>
          )
        }
      </Transition>
    </DialogPrimitive.Root>
  );
}

export default Drawer;
